// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","footerForms":"Footer_footerForms__6JZ1w","imgText":"Footer_imgText__McdVU","textLink":"Footer_textLink__SDtEk"};